import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@material-ui/core';
import moment from 'moment';
import 'moment/locale/zh-tw';
import { LocalizationProvider } from '@material-ui/pickers';
import DateFnsAdapter from '@material-ui/pickers/adapter/moment';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';

import App from './App';
import './common/styles.css';
import { theme } from './config/theme';
import reportWebVitals from './reportWebVitals';
import { AlertProvider } from './units/alert';
import { SettingProvider } from './units/setting';
import { LoadingProvider } from './units/loading';
import { LiffProvider } from './units/liff';
import { CustomCookieConsent } from './components/CustomCookieConsent';

moment.locale('en');

config.autoAddCss = false;

const LIFF_ID = process.env.REACT_APP_LIFF_ID || '';
const LIFF_ONLY_IN_CLIENT = process.env.REACT_APP_LIFF_ONLY_IN_CLIENT !== 'false';

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CustomCookieConsent />
            <LocalizationProvider dateAdapter={DateFnsAdapter}>
                <SettingProvider>
                    <LiffProvider liffId={LIFF_ID} onlyInClient={LIFF_ONLY_IN_CLIENT}>
                        <LoadingProvider>
                            <AlertProvider>
                                <App />
                            </AlertProvider>
                        </LoadingProvider>
                    </LiffProvider>
                </SettingProvider>
            </LocalizationProvider>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
